import { FC, HTMLAttributes } from 'react';

import { Flex } from 'antd';
import cn from 'classnames';

import { EFilters, useFilters } from 'features/Filters';
import { usePlannerDates } from 'features/Planner';
import { formatDate } from 'shared/utils';

import styles from './PlannerDayCell.module.scss';

interface IPlannerDayCellProps extends HTMLAttributes<HTMLDivElement> {
	diff: number;
	isWeek?: boolean;
}

export const PlannerDayCell: FC<IPlannerDayCellProps> = ({ className, diff, isWeek, ...props }) => {
	const { onFilterChange, onMultiFiltersChange } = useFilters();

	const { selectedDate } = usePlannerDates();
	selectedDate.setDate(selectedDate.getDate() + diff);

	const isActive = diff === 0 && !isWeek;
	const isToday = selectedDate.toLocaleDateString() === new Date().toLocaleDateString();
	const isVacation =
		selectedDate.toLocaleDateString('ru-RU', { weekday: 'short' }).toLowerCase() === 'сб' ||
		selectedDate.toLocaleDateString('ru-RU', { weekday: 'short' }).toLowerCase() === 'вс';

	return (
		<Flex
			{...props}
			vertical
			gap={3}
			className={cn(
				styles.day,
				{ [styles.active]: isActive, [styles.today]: isToday, [styles.vacation]: isVacation },
				className,
			)}>
			<Flex align="center" justify="center" className={styles.title}>
				{selectedDate.toLocaleDateString('ru-RU', { weekday: 'short' }).toUpperCase()}
			</Flex>

			<button
				className={styles.date}
				onClick={() => {
					if (isWeek) {
						onMultiFiltersChange(
							[EFilters.PLANNER_TYPE, EFilters.PLANNER_DATE],
							['day', formatDate(selectedDate, 'iso')],
						);
					} else {
						onFilterChange(EFilters.PLANNER_DATE, formatDate(selectedDate, 'iso'));
					}
				}}>
				{selectedDate.toLocaleDateString('ru-RU', { day: '2-digit' })}
			</button>
		</Flex>
	);
};
